/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StoryClosedTimeoutContainer_story = {
    readonly id: string;
    readonly closedAt: string | null;
    readonly " $refType": "StoryClosedTimeoutContainer_story";
};
export type StoryClosedTimeoutContainer_story$data = StoryClosedTimeoutContainer_story;
export type StoryClosedTimeoutContainer_story$key = {
    readonly " $data"?: StoryClosedTimeoutContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"StoryClosedTimeoutContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "StoryClosedTimeoutContainer_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "closedAt",
            "storageKey": null
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = 'fd89ee3b8e17530f4e20b5ae5df5104d';
export default node;
